/* eslint-disable react-hooks/exhaustive-deps */

import React from "react";
import Image from "next/image";
import { Fragment } from "react";

const InviteFriendsBoxInMissions = ({ userReferralsLoading, userReferrals, signupReferralRewardsLoading, signupReferralRewards }) => {
  return (
    <Fragment>
      <div className="missions-user-referrals-orange-box flex flex-col justify-stretch items-stretch rounded-xl shadow-lg px-8 py-4">
        <div className="flex flex-row justify-center items-center uppercase obelixProBold text-2xl lg:text-3xl mb-6 mt-2 text-center text-white w-full">INVITE FRIENDS = BONUS</div>

        <div className="flex flex-row justify-stretch items-center w-full">
          <div className="flex flex-col items-stretch justify-stretch mr-8">
            <Image src={"https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_missions%2Ftreasure_box_trim.png?alt=media&token=b69cfc53-dece-4646-96bd-772ce687929c"} className="w-20 h-20" alt="Treasure Box" width={1000} height={1000} />
          </div>

          <div className="flex flex-col justify-center items-center text-center mb-2">
            <div className="flex flex-col justify-start items-stretch">
              <div className="flex flex-row justify-start items-center text-center text-lg lg:text-2xl mb-4 font-bold text-white obelixProBold">
                YOUR BONUS{" "}:
                <div className="ml-4">
                  {/**
                   * 
                  {!userReferralsLoading && userReferrals && userReferrals.referred_users && !signupReferralRewardsLoading && signupReferralRewards ? (
                    <Fragment>
                      {userReferrals.referred_users
                        .filter((refUser) => refUser.is_active)
                        .map((user) => Math.floor(user.all_time_mxs_gold_with_bonuses / 10))
                        .reduce((a, b) => a + b, 0) + signupReferralRewards.map((reward) => reward.mxs_gold_claimed).reduce((a, b) => a + b, 0)}
                    </Fragment>
                  ) : (
                    0
                  )}
                   */}
                  N/A
                </div>
              </div>

              <div className="text-xs lg:text-sm flex flex-col gothamBook items-start">
                <span>Earn 10% of your friends GOLD balance</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default InviteFriendsBoxInMissions;
